var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"svg-icon",on:{"click":_vm.submitClick}},[_c('Icon',{attrs:{"iconName":_vm.iconName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }